// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__MRu40","checkbox":"switch_checkbox__t3TIA","left":"switch_left__9dPtB","right":"switch_right__MSeYm","switchChecked":"switch_switchChecked__zv1Ds"};